<template>
      <div>
            <date-picker
					v-model="date"
					:config="options"
					
					@dp-hide="showDatePickResult" class="picker"
					/>
      </div>
</template>
<script>

import datePicker from 'vue-bootstrap-datetimepicker'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

import '@fortawesome/fontawesome-free/css/all.css'

export default {
	name: 'date',
	data () {
		return {
			date:"",
			options: {
				format: 'YYYY-MM-DD',
				useCurrent: false,
				locale: 'zh-cn',
				tooltips: {
				  selectTime: ''
				},
				
		        
			},
			
			val:'',
			
		}
	},
	
	methods: {
		showDatePickResult: function () {
			// 
			this.val=this.date;
			this.$emit('changeDate',this.val)
        },
        // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
            // getDay(day) {　　
            //     var today = new Date();　　
            //     var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
            //     today.setTime(targetday_milliseconds); //注意，这行是关键代码
            //     　　
            //     var tYear = today.getFullYear();　　
            //     var tMonth = today.getMonth();　　
            //     var tDate = today.getDate();　　
            //     tMonth = this.doHandleMonth(tMonth + 1);　　
            //     tDate = this.doHandleMonth(tDate);　　
            //     return ""+tYear  + tMonth + tDate;
            // },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },

			getDay(){
				    var today = new Date();　
                    var tYear = today.getFullYear();　　
                    var tMonth = today.getMonth();　　
					tMonth = this.doHandleMonth(tMonth + 1);
					// 
					this.getLastDay(tYear,tMonth)
			},
			getLastDay(year,month) { 
				const that =this        
			 var nMonth = month       
             var new_year = year;    //取当前的年份          
             var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）   
             if(month>12) {         
              new_month -=12;        //月份减          
              new_year++;            //年份增          
             }         
             var new_date = new Date(new_year,new_month,1);                //取当年当月中的第一天          
             var tDate=(new Date(new_date.getTime()-1000*60*60*24)).getDate();//获取当月最后一天日期   
			 that.date = ""+year  + nMonth + tDate;    
			//  
        } 
		
	},
	components: {
		datePicker  
	},
	

	created: function () {
		$.extend(true, $.fn.datetimepicker, {
	  		icons: {
	    		time: 'far fa-clock',
	    		date: 'far fa-calendar',
	    		up: 'fas fa-arrow-up',
	    		down: 'fas fa-arrow-down',
	    		previous: 'fas fa-chevron-left',
	    		next: 'fas fa-chevron-right',
	    		today: 'fas fa-calendar-check',
	    		clear: 'far fa-trash-alt',
	    		close: 'far fa-times-circle'
			  },
			  
        })
        // this.date=this.getDay(0)
		this.getDay()
		
	}
}
</script>
<style scoped>
     .picker{
		 font-size: 10px;
		 height:1.5rem;
		 width:5.5rem;
	 }
</style>




// WEBPACK FOOTER //
// src/components/Date/Date6.vue